import React from "react";
import { connect } from "react-redux";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import UiDispatcher from "../redux/dispatch/UiDispatcher";

const Toaster = ({ open, severity, content, duration }) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    UiDispatcher.hideToaster();
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={duration}
      onClose={handleClose}
      style={{ marginTop: 135 }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={handleClose}
        severity={severity}
      >
        {content}
      </MuiAlert>
    </Snackbar>
  );
};
const mapStateToProps = (state) => ({
  open: state.toaster.open,
  severity: state.toaster.severity,
  content: state.toaster.content,
  duration: state.toaster.duration,
});
export default connect(mapStateToProps)(Toaster);
